'use client';
import { ProductCard } from '@hyphengroup/cms-components/components/ProductCard/ProductCard';
import classNames from 'classnames';
import React, { useState } from 'react';
import { usePageDataContext } from '../../../app/[site]/[locale]/(cms)/_modules/cmsService/pageDataService/pageDataProvider';
import { PersonalLoanFilterWrapper } from '../components-internal/PersonalLoanFilter/wrapper';
import { RecalculateProductAttributes } from '../helpers/calculateComparisonAttribute';
import { LoanSearchParams } from '../helpers/loanSearchParams';
import { useLoanSearchParams } from '../helpers/useLoanSearchParams';
import { pushDataLayer } from '../pushDataLayer';
import { VerticalType } from '../types';
import { ComponentSelectedProducts } from '$/(cms)/_modules/cmsService/types';
import { feApiFrontClient } from '$/(cms)/_modules/feApiClient/feApiFrontClient';

export const ProductListing: React.FC<
  ComponentSelectedProducts & {
    vertical?: VerticalType;
    index?: number;
    loanSearchParams?: LoanSearchParams;
  }
> = (props) => {
  const [_products, setProducts] = useState(props.products);

  const { loanSearchParams: changedLoanSearchParams } = useLoanSearchParams(
    props.loanSearchParams!,
  );

  const {
    pageType,
    pageData: { travelQuotes, plFilterConfig },
    isPreview,
  } = usePageDataContext();

  const onFinishedEnterFilter = async ({
    tenure,
    amount,
  }: LoanSearchParams) => {
    try {
      const productsIds = props.products.map((p) => p.title!);
      const res = await feApiFrontClient.calculatePersonalLoans({
        productIds: productsIds,
        tenure: +tenure,
        amount: +amount,
        isDraft: isPreview,
      });

      if (!res) {
        return;
      }

      const updatedProducts = props.products.map((prod, i) => {
        const newProduct = { ...prod };
        const resultAttr = res[i];
        newProduct.attributes = RecalculateProductAttributes(
          newProduct.attributes,
          resultAttr,
        );
        return newProduct;
      });

      setProducts(updatedProducts);
    } catch (e) {
      console.error('Error updating loan products:', e);
    }
  };

  return (
    <div>
      <PersonalLoanFilterWrapper
        vertical={props.vertical}
        defaultParams={props.loanSearchParams!}
        onFinishedEnterFilter={onFinishedEnterFilter}
        max_loan_amount={props.max_loan_amount}
        max_loan_tenure={props.max_loan_tenure}
        min_loan_amount={props.min_loan_amount}
        min_loan_tenure={props.min_loan_tenure}
      >
        <div
          className={classNames(props.visible_mobile ? 'md:block' : 'hidden')}
        >
          {props.titleReq && (
            <h3 className="alpha-display-1">{props.titleReq}</h3>
          )}
          {_products
            .filter((p) => !!p)
            .map((p, i) => (
              <div className="mt-6" key={p?.uid}>
                <ProductCard
                  vertical={props.vertical}
                  pageType={pageType}
                  key={p?.product_name}
                  componentAttributes={
                    props.attributes?.filter((a) => !!a) ?? []
                  }
                  index={`${props.index}.${i}`}
                  loanSearchParams={changedLoanSearchParams}
                  view_rating
                  highlightFirstAttribute={props.highlightFirstAttribute}
                  product={p!}
                  // SelectedProducts is not used with Car Insurance or Travel Insurance
                  carInsuranceQuote={undefined}
                  carInsuranceSection={undefined}
                  travelInsuranceQuotes={undefined}
                  travelQuotes={travelQuotes}
                  plFilterConfig={plFilterConfig}
                  pushDataLayer={pushDataLayer}
                />
              </div>
            ))}
        </div>
      </PersonalLoanFilterWrapper>
    </div>
  );
};
